<template>
  <page>
    <lazy-div :load="doInit">
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon v-if="newMode">mdi-plus</v-icon>
          <v-icon v-else-if="reviewMode">mdi-pencil</v-icon>
          <v-icon v-else-if="queryMode">mdi-magnify</v-icon>
          <v-toolbar-title v-if="newMode">Create Tariff Factor</v-toolbar-title>
          <v-toolbar-title v-else-if="reviewMode">Edit Tariff Factor</v-toolbar-title>
          <v-toolbar-title v-else-if="queryMode">View Tariff Factor</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn v-if="!newMode" color="primary" @click="doNext()">
            Tariff Rate
            <v-icon right>mdi-view-list</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <message :messages="messages"></message>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <!-- New -->
              <v-flex xs6 v-if="newMode">
                <v-autocomplete
                  :items="buscls"
                  v-model="tariffFactForm.busCls"
                  :label="tariffFactLabel.busCls"
                  item-text="label"
                  item-value="value"
                  :error-messages="errors.collect('tariffFactForm.busCls')"
                  data-vv-name="tariffFactForm.busCls"
                  :data-vv-as="tariffFactLabel.busCls"
                  v-validate="'required'"
                  clearable
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6 v-if="newMode">
                <v-autocomplete
                  :items="tariff"
                  v-model="tariffFactForm.tariff"
                  :label="tariffFactLabel.tariff"
                  item-text="label"
                  item-value="value"
                  :error-messages="errors.collect('tariffFactForm.tariff')"
                  data-vv-name="tariffFactForm.tariff"
                  :data-vv-as="tariffFactLabel.tariff"
                  v-validate="'required'"
                  clearable
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6 v-if="newMode">
                <v-autocomplete
                  :items="benefit"
                  v-model="tariffFactForm.benefit"
                  :label="tariffFactLabel.benefit"
                  item-text="label"
                  item-value="value"
                  :error-messages="errors.collect('tariffFactForm.benefit')"
                  data-vv-name="tariffFactForm.benefit"
                  :data-vv-as="tariffFactLabel.benefit"
                  v-validate="'required'"
                  clearable
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6 v-if="newMode">
                <v-text-field
                  v-model="tariffFactForm.seqNo"
                  :label="tariffFactLabel.seqNo"
                  :error-messages="errors.collect('seqNo')"
                  data-vv-name="seqNo"
                  :data-vv-as="tariffFactLabel.seqNo"
                  v-validate="'required|numeric'"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 v-if="newMode">
                <cal-picker
                  v-model="tariffFactForm.effDate"
                  :label="tariffFactLabel.effDate"
                  :data-vv-as="tariffFactLabel.effDate"
                  data-vv-name="tariffFactForm.effDate"
                  :error-messages="errors.collect('tariffFactForm.effDate')"
                  v-validate="'required'"
                ></cal-picker>
              </v-flex>
              <!-- End New-->

              <!-- Review and Query -->
              <v-flex xs6 v-if="!newMode">
                <v-subheader class="queryLabel">{{ tariffFactLabel.tariff }}</v-subheader>
                <div class="queryValue" v-for="item in filterTariffList" :key="item.label">{{ item.label }}</div>
              </v-flex>
              <v-flex xs6 v-if="!newMode">
                <v-subheader class="queryLabel">{{ tariffFactLabel.busCls }}</v-subheader>
                <div class="queryValue" v-for="item in filterBusClsList" :key="item.label">{{ item.label }}</div>
              </v-flex>
              <v-flex xs6 v-if="!newMode">
                <v-subheader class="queryLabel">{{ tariffFactLabel.benefit }}</v-subheader>
                <div class="queryValue" v-for="item in filterBenefitList" :key="item.label">{{ item.label }}</div>
              </v-flex>
              <v-flex xs6 v-if="!newMode">
                <v-subheader class="queryLabel">{{ tariffFactLabel.seqNo }}</v-subheader>
                <div class="queryValue">{{ tariffFactForm.seqNo }}</div>
              </v-flex>
              <v-flex xs6 v-if="!newMode">
                <v-subheader class="queryLabel">{{ tariffFactLabel.effDate }}</v-subheader>
                <div class="queryValue">{{ convertDate(tariffFactForm.effDate) }}</div>
              </v-flex>

              <!-- End Review -->

              <v-flex xs6 v-if="!queryMode">
                <cal-picker
                  v-model="tariffFactForm.expDate"
                  :label="tariffFactLabel.expDate"
                  :data-vv-as="tariffFactLabel.expDate"
                  data-vv-name="tariffFactForm.expDate"
                  :error-messages="errors.collect('tariffFactForm.expDate')"
                  v-validate="expDateValidation"
                ></cal-picker>
              </v-flex>
              <v-flex xs6 v-else>
                <v-subheader class="queryLabel">{{ tariffFactLabel.expDate }}</v-subheader>
                <div class="queryValue">{{ convertDate(tariffFactForm.expDate) }}</div>
              </v-flex>
              <v-flex xs12 v-if="!queryMode">
                <v-text-field
                  v-model="tariffFactForm.desc"
                  :label="tariffFactLabel.desc"
                  :error-messages="errors.collect('desc')"
                  data-vv-name="desc"
                  :data-vv-as="tariffFactLabel.desc"
                  v-validate="'entry|max:40'"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 v-else>
                <v-subheader class="queryLabel">{{ tariffFactLabel.desc }}</v-subheader>
                <div class="queryValue">{{ tariffFactForm.desc }}</div>
              </v-flex>
              <v-flex xs6 v-if="!queryMode">
                <v-autocomplete
                  :items="factor_isnum"
                  v-model="tariffFactForm.fact1"
                  :label="tariffFactLabel.fact1"
                  item-text="label"
                  item-value="value"
                  :error-messages="errors.collect('tariffFactForm.fact1')"
                  data-vv-name="tariffFactForm.fact1"
                  :data-vv-as="tariffFactLabel.fact1"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6 v-else>
                <v-subheader class="queryLabel">{{ tariffFactLabel.fact1 }}</v-subheader>
                <div class="queryValue" v-for="item in filterFact1List" :key="item.label">{{ item.label }}</div>
              </v-flex>
              <v-flex xs6 v-if="!queryMode">
                <v-autocomplete
                  :items="factor_isnum"
                  v-model="tariffFactForm.fact2"
                  :label="tariffFactLabel.fact2"
                  item-text="label"
                  item-value="value"
                  :error-messages="errors.collect('tariffFactForm.fact2')"
                  data-vv-name="tariffFactForm.fact2"
                  :data-vv-as="tariffFactLabel.fact2"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6 v-else>
                <v-subheader class="queryLabel">{{ tariffFactLabel.fact2 }}</v-subheader>
                <div class="queryValue" v-for="item in filterFact2List" :key="item.label">{{ item.label }}</div>
              </v-flex>
              <v-flex xs6 v-if="!queryMode">
                <v-autocomplete
                  :items="factor_isnum"
                  v-model="tariffFactForm.fact3"
                  :label="tariffFactLabel.fact3"
                  item-text="label"
                  item-value="value"
                  :error-messages="errors.collect('tariffFactForm.fact3')"
                  data-vv-name="tariffFactForm.fact3"
                  :data-vv-as="tariffFactLabel.fact3"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6 v-else>
                <v-subheader class="queryLabel">{{ tariffFactLabel.fact3 }}</v-subheader>
                <div class="queryValue" v-for="item in filterFact3List" :key="item.label">{{ item.label }}</div>
              </v-flex>
              <v-flex xs6 v-if="!queryMode">
                <v-autocomplete
                  :items="factor_notnum"
                  v-model="tariffFactForm.fact4"
                  :label="tariffFactLabel.fact4"
                  item-text="label"
                  item-value="value"
                  :error-messages="errors.collect('tariffFactForm.fact4')"
                  data-vv-name="tariffFactForm.fact4"
                  :data-vv-as="tariffFactLabel.fact4"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6 v-else>
                <v-subheader class="queryLabel">{{ tariffFactLabel.fact4 }}</v-subheader>
                <div class="queryValue" v-for="item in filterFact4List" :key="item.label">{{ item.label }}</div>
              </v-flex>
              <v-flex xs6 v-if="!queryMode">
                <v-autocomplete
                  :items="factor_notnum"
                  v-model="tariffFactForm.fact5"
                  :label="tariffFactLabel.fact5"
                  item-text="label"
                  item-value="value"
                  :error-messages="errors.collect('tariffFactForm.fact5')"
                  data-vv-name="tariffFactForm.fact5"
                  :data-vv-as="tariffFactLabel.fact5"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6 v-else>
                <v-subheader class="queryLabel">{{ tariffFactLabel.fact5 }}</v-subheader>
                <div class="queryValue" v-for="item in filterFact5List" :key="item.label">{{ item.label }}</div>
              </v-flex>
              <v-flex xs6 v-if="!queryMode">
                <v-autocomplete
                  :items="factor_notnum"
                  v-model="tariffFactForm.fact6"
                  :label="tariffFactLabel.fact6"
                  item-text="label"
                  item-value="value"
                  :error-messages="errors.collect('tariffFactForm.fact6')"
                  data-vv-name="tariffFactForm.fact6"
                  :data-vv-as="tariffFactLabel.fact6"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6 v-else>
                <v-subheader class="queryLabel">{{ tariffFactLabel.fact6 }}</v-subheader>
                <div class="queryValue" v-for="item in filterFact6List" :key="item.label">{{ item.label }}</div>
              </v-flex>
            </v-layout>

            <v-layout row wrap>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ tariffFactLabel.createdBy }}</v-subheader>
                <div class="queryValue">{{ tariffFactForm.createdBy }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ tariffFactLabel.createdDate }}</v-subheader>
                <div class="queryValue">{{ tariffFactForm.createdDate | formatDate }}</div>
              </v-flex>
              <v-flex xs6 v-if="!newMode">
                <v-subheader class="queryLabel">{{ tariffFactLabel.modifiedBy }}</v-subheader>
                <div class="queryValue">{{ tariffFactForm.modifiedBy }}</div>
              </v-flex>
              <v-flex xs6 v-if="!newMode">
                <v-subheader class="queryLabel">{{ tariffFactLabel.modifiedDate }}</v-subheader>
                <div class="queryValue">{{ tariffFactForm.modifiedDate | formatDate }}</div>
              </v-flex>
              <v-btn color="red darken-1" dark class=" mr-2" @click.native="doCancel">
                Cancel
                <v-icon right dark>mdi-cancel</v-icon>
              </v-btn>
              <v-btn v-if="!queryMode" color="primary" dark class=" mr-2" @click="doSave" :loading="submitting">
                Save
                <v-icon right>mdi-content-save</v-icon>
              </v-btn>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </lazy-div>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import { expandURI } from '@/utils/ajax'
import { formatDisplayDate, formatDisplayDateTime2, removeTime } from '@/utils/date'
import isAfter from 'date-fns/isAfter'
import clone from 'clone'

export default {
  data() {
    return {
      submitting: false,
      loading: false,
      newMode: false,
      reviewMode: false,
      queryMode: false,
      buscls: [],
      tariff: [],
      benefit: [],
      factor_isnum: [],
      factor_notnum: [],
      tariffPermitted: false,
      tariffFactLabel: {
        busCls: 'Business Class',
        tariff: 'Tariff',
        benefit: 'Benefit',
        seqNo: 'Sequence No',
        effDate: 'Effective Date',
        expDate: 'Expiry Date',
        desc: 'Description',
        fact1: 'Factor 1',
        fact2: 'Factor 2',
        fact3: 'Factor 3',
        fact4: 'Factor 4',
        fact5: 'Factor 5',
        fact6: 'Factor 6',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date'
      },
      tariffFactForm: {
        busCls: null,
        tariff: null,
        benefit: null,
        seqNo: '0',
        effDate: null,
        expDate: null,
        desc: null,
        fact1: null,
        fact2: null,
        fact3: null,
        fact4: null,
        fact5: null,
        fact6: null,
        createdBy: null,
        createdDate: null,
        modifiedBy: null,
        modifiedDate: null
      },
      processingFlag: false,
      showPromptLeave: true,
      showErrorDialog: false
    }
  },
  methods: {
    async doInit() {
      await Promise.all([this.$store.dispatch('commonsInit')])
      this.getCommonDataListDropDown('buscls')
      this.getCommonDataListDropDown('tariff')
      this.getCommonDataListDropDown('benefit')
      this.getCommonDataListDropDown('factor_isnum')
      this.getCommonDataListDropDown('factor_notnum')
      if (this.newTariffFact) {
        this.tariffFactForm.createdBy = this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName
        this.tariffFactForm.createdDate = new Date()
        this.tariffFactForm.effDate = new Date()
        this.tariffFactForm.expDate = this.tariffFactForm.effDate
      } else {
        this.fetchData()
      }
    },
    async fetchData() {
      const apiURI = this.menu.getTariffFact
      if (apiURI) {
        try {
          const expand = {
            tariff: this.tariffFactId.tariff,
            busCls: this.tariffFactId.busCls,
            benefit: this.tariffFactId.benefit,
            seqNo: this.tariffFactId.seqNo,
            effDate: formatDisplayDateTime2(removeTime(this.tariffFactId.effDate))
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.tariffFactForm.tariff = data.tarfFact.tariff
            this.tariffFactForm.busCls = data.tarfFact.busCls
            this.tariffFactForm.benefit = data.tarfFact.benefit
            this.tariffFactForm.seqNo = data.tarfFact.seqNo
            this.tariffFactForm.effDate = data.tarfFact.effDate
            this.tariffFactForm.desc = data.tarfFact.desc
            this.tariffFactForm.expDate = data.tarfFact.expDate
            this.tariffFactForm.fact1 = data.tarfFact.fact1
            this.tariffFactForm.fact2 = data.tarfFact.fact2
            this.tariffFactForm.fact3 = data.tarfFact.fact3
            this.tariffFactForm.fact4 = data.tarfFact.fact4
            this.tariffFactForm.fact5 = data.tarfFact.fact5
            this.tariffFactForm.fact6 = data.tarfFact.fact6
            this.tariffFactForm.createdBy = data.createdBy
            this.tariffFactForm.createdDate = data.createdDate
            this.tariffFactForm.modifiedBy = data.modifiedBy
            this.tariffFactForm.modifiedDate = data.modifiedDate
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doSave() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.checkTariffPermitted().then((result) => {
            if (result) {
              this.checkBenefitPermitted().then((result) => {
                if (result) {
                  if (this.newTariffFact) {
                    this.doCreate()
                  } else {
                    this.doUpdate()
                  }
                }
              })
            }
          })
        } else {
          this.promptFieldCheck()
        }
      })
    },
    doCancel() {
      this.$router.push({ name: 'tarfFactor' })
    },
    async doCreate() {
      const apiURI = this.menu.createTariffFact
      if (apiURI) {
        let messageFilters = clone(this.tariffFactForm)
        if (messageFilters.effDate !== null && messageFilters.effDate !== '') {
          messageFilters.effDate = formatDisplayDateTime2(removeTime(messageFilters.effDate))
        }

        if (messageFilters.expDate !== null && messageFilters.expDate !== '') {
          messageFilters.expDate = formatDisplayDateTime2(removeTime(messageFilters.expDate))
        }
        this.$http
          .post(apiURI, messageFilters)
          .then((result) => {
            const { data } = result
            if (data) {
              this.$router.push({ name: 'tarfFactor' })
              this.notify(data)
            }
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
      }
    },
    async doUpdate() {
      const apiURI = this.menu.updateTariffFact
      if (apiURI) {
        this.submitting = true
        let messageFilters = clone(this.tariffFactForm)

        if (messageFilters.effDate !== null && messageFilters.effDate !== '') {
          messageFilters.effDate = formatDisplayDateTime2(removeTime(messageFilters.effDate))
        }

        if (messageFilters.expDate !== null && messageFilters.expDate !== '') {
          messageFilters.expDate = formatDisplayDateTime2(removeTime(messageFilters.expDate))
        }

        try {
          const result = await this.$http.put(apiURI, messageFilters)
          const { data } = result
          if (data) {
            this.notify(data)
            this.$router.push({ name: 'tarfFactor' })
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async checkTariffPermitted() {
      const apiUrl = this.menu.checkTariffPermit
      if (apiUrl) {
        try {
          const params = {
            busCls: this.tariffFactForm.busCls,
            tariff: this.tariffFactForm.tariff
          }
          const response = await this.$http.get(expandURI(apiUrl, params))
          const { data } = response.data
          this.resetMessages()
          if (data) {
            if (data === 'false') {
              const errMsg = {
                messages: [{ message: 'Not on Tariff Permitted per Business Class File xBusClsTarf.(10098)', type: 'ERROR' }]
              }
              this.message(errMsg)
              this.fieldMessage(errMsg)
              return false
            }
          }
          return true
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
          return false
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
        return false
      }
    },
    async checkBenefitPermitted() {
      const apiUrl = this.menu.checkBenefitPermit
      if (apiUrl) {
        try {
          const params = {
            busCls: this.tariffFactForm.busCls,
            benefit: this.tariffFactForm.benefit
          }
          const response = await this.$http.get(expandURI(apiUrl, params))
          const { data } = response.data
          this.resetMessages()
          if (data) {
            if (data === 'false') {
              const errMsg = {
                messages: [{ message: 'Not found in Permitted Benefit per Business Class file.(10462)', type: 'ERROR' }]
              }
              this.message(errMsg)
              this.fieldMessage(errMsg)
              return false
            }
          }
          return true
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
          return false
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
        return false
      }
    },
    doNext() {
      this.$router.push({ name: 'tarfRate' })
    },
    convertDate(date) {
      if (date !== null) {
        return formatDisplayDate(date)
      }
    }
  },
  created() {
    const jsonData = JSON.parse(sessionStorage.getItem('tariffFact'))
    this.$store.commit('TARIFF_FACTOR_COMMIT_KEY', jsonData)

    if (this.tariffFactId.tarfFactMode !== '') {
      if (this.tariffFactId.tarfFactMode === 'New') {
        this.newMode = true
      } else if (this.tariffFactId.tarfFactMode === 'Review') {
        this.reviewMode = true
      } else if (this.tariffFactId.tarfFactMode === 'Query') {
        this.queryMode = true
      }
    }

    this.$validator.extend('valExpiry', {
      getMessage(field, args) {
        return 'Expiry Date must be equal or greater than Effective Date'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var expDate = args[0]
        if (expDate) {
          return !isAfter(removeTime(expDate), removeTime(value))
        }
      }
    })
  },
  computed: {
    menu() {
      return this.$store.state.tariffFactorParam.menu
    },
    newTariffFact() {
      return this.tariffFactId.tarfFactMode === 'New'
    },
    tariffFactId() {
      return this.$store.state.tariffFactorParam.tarfFact.tarfFactId
    },
    expDateValidation() {
      if (this.tariffFactForm.expDate !== '' && this.tariffFactForm.expDate !== null) {
        return 'entry|valExpiry:' + this.tariffFactForm.effDate
      } else {
        return ''
      }
    },
    filterTariffList() {
      return this.tariff.filter((list) => {
        return list.value === this.tariffFactForm.tariff
      })
    },
    filterBusClsList() {
      return this.buscls.filter((list) => {
        return list.value === this.tariffFactForm.busCls
      })
    },
    filterBenefitList() {
      return this.benefit.filter((list) => {
        return list.value === this.tariffFactForm.benefit
      })
    },
    filterFact1List() {
      return this.factor_isnum.filter((list) => {
        return list.value === this.tariffFactForm.fact1
      })
    },
    filterFact2List() {
      return this.factor_isnum.filter((list) => {
        return list.value === this.tariffFactForm.fact2
      })
    },
    filterFact3List() {
      return this.factor_isnum.filter((list) => {
        return list.value === this.tariffFactForm.fact3
      })
    },
    filterFact4List() {
      return this.factor_notnum.filter((list) => {
        return list.value === this.tariffFactForm.fact4
      })
    },
    filterFact5List() {
      return this.factor_notnum.filter((list) => {
        return list.value === this.tariffFactForm.fact5
      })
    },
    filterFact6List() {
      return this.factor_notnum.filter((list) => {
        return list.value === this.tariffFactForm.fact6
      })
    }
  },
  filters: {
    formatDate(value) {
      return formatDisplayDate(value)
    }
  },
  mixins: [MessageMixin, commonAjaxMixin]
}
</script>
